import { __decorate } from "tslib";
import { __metadata } from "tslib";
import { Component, Input } from '@angular/core';
var ActionButtonComponent = /*@__PURE__*/ (function () {
    /**
     * TypeScript public modifiers
     */
    function ActionButtonComponent() {
        this.disabled = false;
        /**
         * Set our default values
         */
        this.localState = { value: '' };
    }
    ActionButtonComponent.prototype.ngOnInit = function () {
    };
    ActionButtonComponent.prototype.submitState = function (value) {
    };
    return ActionButtonComponent;
}());
export { ActionButtonComponent };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/shared/components/action-button/action-button.component.ts
// module id = null
// module chunks = 